import { createFileRoute } from "@tanstack/react-router";
import { HostingSalesPage } from "@/components/site/hosting-sales-page";
import { getHostingPageMeta } from "@/lib/hosting-public.functions";

const SLUG = "hosting/vps-cloud";
const CANONICAL = "/hosting/vps-cloud";
const FALLBACK_TITLE = "VPS & Cloud Hosting — Scalable NVMe Servers";
const FALLBACK_DESC = "Production-grade VPS and cloud servers with dedicated vCPU, NVMe SSD, snapshots, DDoS protection and auto-scaling.";

export const Route = createFileRoute("/hosting/vps-cloud/")({
  component: VpsCloudIndex,
  loader: () => getHostingPageMeta({ data: { slug: SLUG } }).catch(() => null),
  head: ({ loaderData }) => {
    const meta = loaderData ?? null;
    const title = meta?.seo_title || meta?.title || FALLBACK_TITLE;
    const desc = meta?.seo_description || meta?.subtitle || FALLBACK_DESC;
    const image = meta?.og_image_url || meta?.hero_image_url || undefined;
    const tags: Array<Record<string, string>> = [
      { title },
      { name: "description", content: desc },
      { property: "og:title", content: title },
      { property: "og:description", content: desc },
      { property: "og:type", content: "website" },
      { property: "og:url", content: CANONICAL },
      { name: "twitter:card", content: image ? "summary_large_image" : "summary" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: desc },
    ];
    if (image) {
      tags.push({ property: "og:image", content: image });
      tags.push({ name: "twitter:image", content: image });
    }
    return { meta: tags, links: [{ rel: "canonical", href: CANONICAL }] };
  },
});

function VpsCloudIndex() {
  return <HostingSalesPage slug={SLUG} />;
}
